import { render, staticRenderFns } from "./extra-mein-schreibtisch-prozesse.vue?vue&type=template&id=53c22dfe&scoped=true&lang=pug&"
import script from "./extra-mein-schreibtisch-prozesse.vue?vue&type=script&lang=js&"
export * from "./extra-mein-schreibtisch-prozesse.vue?vue&type=script&lang=js&"
import style0 from "./extra-mein-schreibtisch-prozesse.vue?vue&type=style&index=0&id=53c22dfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c22dfe",
  null
  
)

export default component.exports